export function getFirstNameFromAuthUser(
  user: { given_name?: string; name?: string } | null | undefined,
) {
  const givenName = user?.given_name?.trim()
  if (givenName) return givenName

  const displayName = user?.name?.trim()
  if (!displayName) return null

  const firstName = displayName.split(/\s+/)[0]?.trim()
  return firstName != null && firstName.length > 0 ? firstName : null
}

export function resolveCreateUserFirstName({
  pendingSignupFirstName,
  authUser,
}: {
  pendingSignupFirstName: string | null
  authUser: { given_name?: string; name?: string } | null | undefined
}) {
  const pendingFirstName = pendingSignupFirstName?.trim()
  if (pendingFirstName != null && pendingFirstName.length > 0) {
    return pendingFirstName
  }

  return getFirstNameFromAuthUser(authUser)
}
